// 사이트 전역 정보. 푸터, /legal, 정책 본문, mailto가 이 값을 쓴다.
export const SITE = {
  domain: "kwangbok.me",
  owner: "이광복",
  developer: "이광복", // 스토어 등록 개발자 이름 (D-11)
  email: "siu9068@gmail.com",
  linkedin: "https://www.linkedin.com/in/siu9068/",
  resume_pdf: "/resume.pdf", // D-14
  portfolio_pdf: "/portfolio.pdf", // 앱별 설계 고민. 상세 화면에서 뺀 아키텍처와 기술 결정을 여기로 옮겼다
  support_reply_days: "영업일 기준 3일", // D-12
  deletion_days: 30, // D-13
};

export const mailto = (subject?: string, body?: string, to: string = SITE.email) =>
  `mailto:${to}` +
  (subject || body
    ? `?${new URLSearchParams({ ...(subject ? { subject } : {}), ...(body ? { body } : {}) })
        .toString()
        .replace(/\+/g, "%20")}`
    : "");
